import { render, staticRenderFns } from "./NewChannel.vue?vue&type=template&id=1eb6f46b"
import script from "./NewChannel.vue?vue&type=script&lang=js"
export * from "./NewChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports